import React from 'react'
import { Avatar, Body, Card, getImgProps, TextVerticalSpacer } from '@superhi/design'

type Level = '1' | '2'

const BODY_LEVEL: Record<Level, React.ComponentProps<typeof Body>['level']> = {
  '1': '2',
  '2': '3',
}

const AVATAR_SIZE: Record<Level, React.ComponentProps<typeof Avatar>['size']> = {
  '1': {
    small: 40,
    medium: 56,
    large: 64,
  },
  '2': {
    small: 40,
    medium: 40,
    large: 40,
  },
}

type Props = {
  text: string
  authorName: string
  authorLocation: string
  imageUrl: string
  level?: Level
  border?: boolean
}

const TestimonialCard: React.FC<React.PropsWithChildren<Props>> = ({
  text,
  authorLocation,
  authorName,
  imageUrl,
  level = '2',
  border,
}) => {
  const imageProps = React.useMemo(
    () =>
      getImgProps(imageUrl, {
        small: 5,
        medium: 5,
        large: 5,
        xlarge: 5,
      }),
    [imageUrl],
  )

  return (
    <Card level="1" elevated={false} border={border}>
      <TextVerticalSpacer level="2">
        <Avatar image={imageProps} size={AVATAR_SIZE[level]} />
        <Body level={BODY_LEVEL[level]} maxWidth={38}>
          &ldquo;{text}&rdquo;
        </Body>
        <Body level={BODY_LEVEL[level]} color="GREY_70">
          &mdash; {authorName}, {authorLocation}
        </Body>
      </TextVerticalSpacer>
    </Card>
  )
}

export default TestimonialCard
